/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilmCross: {
  name: 'film-cross';
  data: string;
} = {
  name: 'film-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="m18.5 6.914-.793.793a1 1 0 1 1-1.414-1.414l.793-.793-.793-.793a1 1 0 0 1 1.414-1.414l.793.793.793-.793a1 1 0 1 1 1.414 1.414l-.793.793.793.793a1 1 0 0 1-1.414 1.414l-.793-.793ZM5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a1 1 0 1 0-2 0h-2a1 1 0 1 0-2 0v8H9V5h4a1 1 0 1 0 0-2H5Zm2 12v-2H5v2h2Zm-2 2h2v2H5v-2Zm14-4v2h-2v-2h2Zm0 4h-2v2h2v-2ZM7 11V9H5v2h2Zm0-4V5H5v2h2Z" fill="currentColor"/></svg>`,
};
